import JsCollapse from './js_collapse.vue'
export {JsCollapse}


// WEBPACK FOOTER //
// ./src/js_components/index.js